import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CouponFilter, CouponsData } from '../types';
import { CouponsState } from './types';

const initialState: CouponsState = {
  loading: {
    getCoupons: false,
    generateCoupons: false,
  },
  couponList: { items: [], totalCount: 0 },
  error: null,
  filter: {
    search: '',
    pageNumber: 0,
    pageSize: 15,
    status: [],
    orderedby: 'id,desc',
  },
};

export const CouponsSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {
    setIsLoading(
      state,
      action: PayloadAction<Partial<Record<keyof CouponsState['loading'], boolean>>>,
    ) {
      state.loading = { ...state.loading, ...action.payload };
    },
    setCouponsList(state, action: PayloadAction<CouponsData>) {
      state.couponList = action.payload;
    },
    setCouponsListError(state, action: PayloadAction<Error>) {
      state.error = action.payload;
    },
    setFilter(state, action: PayloadAction<Partial<CouponFilter>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
  },
});

const { actions, reducer } = CouponsSlice;
export default reducer;
export const { setIsLoading, setCouponsList, setCouponsListError, setFilter } = actions;
